import React, { PureComponent } from "react";
import styles from "./Sidebar.local.scss";

import AuthorsComponent from "../../Community/NewCommunity/Authors/AuthorsComponent";
import SocialContainer from "../../Community/NewCommunity/Social/SocialContainer";
import Comments from "../Comments";

import { getDateLabel } from "Utils";

export default class Sidebar extends PureComponent {
  render() {
    const { currentResource, type } = this.props;

    if (!currentResource) {
      return null;
    }
    const { author, publishedAt, creator, isExternal } = currentResource;

    let helpUser =
      isExternal && creator ? [{ ...creator, enableAvatar: true }] : [];
    if (!isExternal && author) {
      helpUser = author;
    }

    return (
      <div className={styles.sidebar}>
        <div className="grid-x article-authors">
          <AuthorsComponent
            authors={helpUser ? helpUser : []}
            fromViewer={true}
          />
          <div className="article-file-date">{getDateLabel(publishedAt)}</div>
        </div>
        <SocialContainer
          resource={currentResource}
          fromViewer={true}
          type={type}
        />
        <Comments currentResource={currentResource} type={type} />
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/Reveal/Sidebar/index.js